import type React from 'react';

// Появление экранов главной: экран, который ещё не показывали за этот визит,
// получает класс rv-wait (элементы скрыты), а когда до него долистали — класс
// снимается и элементы плавно появляются. Один раз за визит: при возврате на
// главную показанные экраны сразу на месте. Эффекты — rv-* в index.css.

const SECTION_IDS = ['advantages', 'slidercontainer', 'howtoinstall', 'latestnews', 'faq', 'community'];
const shown = new Set<string>();

/** Задержка появления элемента (секунды). */
export const rvDelay = (seconds: number) => ({ '--rv-d': `${seconds}s` }) as React.CSSProperties;

/** Включить появление экранов главной. Возвращает функцию отключения. */
export function startSectionReveal(root: HTMLElement): () => void {
  const io = new IntersectionObserver(
    (entries) => entries.forEach((en) => {
      if (!en.isIntersecting) return;
      en.target.classList.remove('rv-wait');
      shown.add(en.target.id);
      io.unobserve(en.target);
    }),
    { root, threshold: 0.3 },
  );
  const seen = new Set<Element>();
  const scan = () => {
    SECTION_IDS.forEach((id) => {
      const el = document.getElementById(id);
      if (!el || seen.has(el)) return;
      seen.add(el);
      if (shown.has(id)) return;
      el.classList.add('rv-wait');
      io.observe(el);
    });
  };
  scan();
  // Новости и FAQ появляются после загрузки данных
  const poll = window.setInterval(scan, 500);
  return () => {
    window.clearInterval(poll);
    io.disconnect();
  };
}
